module.exports = __webpack_public_path__ + "img/5.3616ebd4.jpg";